import { render, staticRenderFns } from "./wardUserPasswordReset.vue?vue&type=template&id=6458c4a6&scoped=true&"
import script from "./wardUserPasswordReset.vue?vue&type=script&lang=js&"
export * from "./wardUserPasswordReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6458c4a6",
  null
  
)

export default component.exports